import { encryptor } from "../../../Services/Crypto/Crypto";
import { PrivateInterceptor } from "../../../interceptors/PrivateInterceptor";

export const loginUser = async (user, password) => {
  let ip = null;
  let result = null;

  const usuarioBase64 = await encryptor(user);
  const passwordBase64 = await encryptor(password);
  // Obtener el token de la variable de entorno
  const token = process.env.REACT_APP_API_TOKEN;
  const promesa = await fetch(
    `${process.env.REACT_APP_API_URL}/IT/users/login?${Date.now()}`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        withCredentials: true,
        "x-access-token": token,
      },
      body: JSON.stringify({
        Usuario: usuarioBase64,
        Password: passwordBase64,
        IP: ip,
        subscription: null,
        divece: "web",
      }),
    }
  );
  await promesa
    .json()
    .then(async (res) => {
      result = res;
    })
    .catch((error) => {
      console.log("error", error);
    });
  return result;
};

// OBTENER LOS PERMISOS DE UN USUARIO
export const getPermisos = async (IdUser) => {
  const respuesta = await PrivateInterceptor(`IT/Permisos/${IdUser}`, "GET");
  return respuesta;
};

// ACTUALIZA EL TIEMPO DE VENCIMIENTO DEL TOKEN DEL USUARIO
export const VencimientoToken = async (IdUser) => {
  const respuesta = await PrivateInterceptor(`IT/Sesiones/${IdUser}`, "PUT");
  return respuesta;
};

export const continuarSesion = async () => {
  const respuesta = await PrivateInterceptor(`IT/Users/getNewToken`, "GET");
  return respuesta;
};

// cambiar webconfig
export const changeWebConfig = async (IdUser, WebConfig) => {
  const result = await PrivateInterceptor(`IT/Users/changeWebConfig/${IdUser}`,"POST",{ WebConfig });
  return result;
};

export const getUserByRol = async (IdRol) => {
  const respuesta = await PrivateInterceptor(
    `Users/usersCSM/byRol/${IdRol}`,
    "GET"
  );
  return respuesta;
};

// MODIFICA UN USUARIO
export const updateUser = async(user) => {
  const respuesta = await PrivateInterceptor(`IT/Users/register`, 'POST', user)
  return respuesta;
}

// MODIFICAR CONTRASEÑA DE UN USUARIO
export const updatePassword = async (user) => {
  const respuesta = await PrivateInterceptor(`IT/Users/password`, "PUT", user);
  return respuesta;
};

// OBTENER TODOS LOS dbo.User con su ID, UserName, Usuario
export const getUsersBasic = async () => {
  const respuesta = await PrivateInterceptor(
    `IT/Users/seleccionUsuarios`,
    "GET"
  );
  return respuesta;
};


export const getAccesos = async (IdUser) => {
  const respuesta = await PrivateInterceptor(`IT/Accesos/${IdUser}`, 'GET')
  return respuesta;
}

export const getUsuarios = async() => {
  const result = await PrivateInterceptor(`IT/Users`, 'GET')
  return result;
}

export const getUsuariosActivos = async() => {
  const result = await PrivateInterceptor(`IT/Users/UsuariosActivos`, 'GET')
  return result;
}


export const getPassUser = async (data) => {
  // console.log(data)
  try {
      const result = await PrivateInterceptor(`IT/Users/getPassUser`, 'POST', {data});
      // console.log("Respuesta del servidor:", result);
      return result;
  } catch (error) {
      console.error("Error al obtener la contraseña del usuario:", error);
      throw error; // Lanza el error para que sea manejado por el código que llama a esta función
  }
}

// AGREGAR UN USUARIO
export const addUser = async(user) => {
  const respuesta = await PrivateInterceptor(`IT/Users/register`, 'POST', user)
  return respuesta;
}

export const EliminarAcceso = async(IdUser, IdAccess) => {
  const respuesta = await PrivateInterceptor(`IT/Users/EliminarAcceso`, 'POST', {IdUser, IdAccess})
  return respuesta;
}

export const getCorreos = async (IdListaCorreo) => {
  const result = await PrivateInterceptor(`IT/Users/ListaCorreo/${IdListaCorreo}`)
  return result
 }

export const getFirmasPersonales = async (Codigo) => {
  const respuesta = await PrivateInterceptor(`IT/Users/getFirma/` + Codigo, 'GET')
  return respuesta;
}

export const getFoto = async (Codigo) => {
  const respuesta = await PrivateInterceptor(`IT/Users/getFoto/` + Codigo, 'GET')
  return respuesta;
}

export const mostrarFoto = async (Codigo, nombre) => {
  const respuesta = await PrivateInterceptor(`IT/Users/getFoto/${Codigo}/${nombre}`, 'GET')
  var binary = '';
  var bytes = [].slice.call(new Uint8Array(respuesta.data));
  bytes.forEach((b) => binary += String.fromCharCode(b));
  const base64String = window.btoa(binary);
  return base64String;
}

export const descargarFotos = async (Codigo, nombre) => {
  const respuesta = await PrivateInterceptor(`IT/Users/DescargarFoto/${Codigo}/${nombre}`, 'GET')
  return respuesta;
}

export const eliminarFotoPersonal = async (Codigo, nombre) => {
  const respuesta = await PrivateInterceptor(`IT/Users/deleteFile/Foto/${Codigo}/${nombre}`, 'DELETE')
  return respuesta;
}